import { projectNamespace } from "../core";

export const triggersNamespace = `${projectNamespace}triggers/`